import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import api from '../../api';
import Bottom from './Bottom';
import { computed } from 'mobx';
import PaymentTypeEnum from '../../enums/PaymentTypeEnum';

@inject('commonStore', 'menuStore', 'orderStore')
@observer
class PaymentCoam extends Component {
  formRef = React.createRef();

  componentDidMount() {
    const { orderStore } = this.props;
    // 결제 방법 기본값을 카드로 설정
    if (!orderStore.paymentMethod) {
      orderStore.setPaymentMethod('1');
    }
  }

  /** 결제방법 변경 */
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  @computed
  get merchantID() {
    const { menuStore, orderStore } = this.props;
    if (orderStore.paymentMethod === '1') {
      // 카드결제
      return menuStore.storeData.merchantID;
    } else {
      // 간편결제
      return menuStore.storeData.merchantID2;
    }
  }

  /** 결제 방법 코드 조회 */
  @computed
  get payBrand() {
    switch (this.props.orderStore.paymentMethod) {
      case '1':
        return 'OCC';
      case '2':
        return 'KKP';
      case '4':
        return 'NAP';
      case '8':
        return 'PAC';
      case '16':
        return 'SSG';
      case '32':
        return 'LPY';
      default:
        return '';
    }
  }

  /** 결제 진행 */
  pay = async () => {
    const { commonStore, orderStore } = this.props;
    try {
      // 주문 저장
      orderStore.setPaymentType(PaymentTypeEnum.COAM);
      const response = await api.addOrder(orderStore.orderData);

      // 결제 요청 데이터 세팅
      orderStore.setPaymentData(response.data);
    } catch (error) {
      commonStore.setError(error);
      throw error;
    } finally {
      // 결제 버튼 활성화
      orderStore.setDisablePaymentButton(false);
    }
    // 결제 페이지 호출
    this.formRef.submit();
  };

  render() {
    const { t, commonStore, menuStore, orderStore } = this.props;
    return (
      <React.Fragment>
        {/* 결제방법 선택 */}
        <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
          <Grid item>
            <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
          </Grid>
          <Grid item>
            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={orderStore.paymentMethod}
              onChange={this.handlePayMethodChange}
            >
              {(menuStore.storeData.paymentMethod & 1) === 1 && (
                <FormControlLabel value={1} control={<Radio color="primary" />} label={'카드'} />
              )}
              {(menuStore.storeData.paymentMethod & 2) === 2 && (
                <FormControlLabel value={2} control={<Radio color="primary" />} label={'카카오페이'} />
              )}
              {(menuStore.storeData.paymentMethod & 4) === 4 && (
                <FormControlLabel value={4} control={<Radio color="primary" />} label={'네이버페이'} />
              )}
              {(menuStore.storeData.paymentMethod & 8) === 8 && (
                <FormControlLabel value={8} control={<Radio color="primary" />} label={'페이코'} />
              )}
              {(menuStore.storeData.paymentMethod & 16) === 16 && (
                <FormControlLabel value={16} control={<Radio color="primary" />} label={'SSG페이'} />
              )}
              {(menuStore.storeData.paymentMethod & 32) === 32 && (
                <FormControlLabel value={32} control={<Radio color="primary" />} label={'L페이'} />
              )}
              {menuStore.storeData.isEzwelPayUsed && (
                <FormControlLabel value={0} control={<Radio color="primary" />} label={'이지웰페이'} />
              )}
            </RadioGroup>
          </Grid>
        </Grid>

        <form
          ref={ref => (this.formRef = ref)}
          name="payForm"
          method="post"
          action={
            process.env.REACT_APP_COAM_URL +
            (isMobile ? '/mobilepage/common/mainFrame.pay' : '/paypage/common/mainFrame.pay')
          }
        >
          {/************************* 공통 필수 *************************/}
          {/* 상점 ID */}
          <input type="hidden" name="mid" value={this.merchantID} />
          {/* Return URL */}
          <input type="hidden" name="rUrl" value={`${process.env.REACT_APP_SMARTORDER_API_URL}/sales/coam`} />
          {/* Return Http메소드 */}
          <input type="hidden" name="rMethod" value="POST" />
          {/* 결제 그룹 */}
          <input type="hidden" name="payGroup" value="OPG" />
          {/* 결제 수단 */}
          <input type="hidden" name="payType" value="CC" />
          {/* 결제 수단 */}
          <input type="hidden" name="payBrand" value={this.payBrand} />
          {/* 상품명 */}
          <input type="hidden" name="buyItemnm" value={orderStore.paymentMenuName} />
          {/* 상품가격 */}
          <input type="hidden" name="buyReqamt" value={orderStore.paymentAmount} />
          {/* #상품 코드 */}
          <input type="hidden" name="buyItemcd" value={orderStore.paymentMenuCode} />
          {/* 주문번호 */}
          <input type="hidden" name="orderno" value={orderStore.paymentData.orderId} />
          {/* 주문 일자 (YYYYMMDD) */}
          <input type="hidden" name="orderdt" value={orderStore.paymentData.ediDate} />
          {/* 주문 시간 (HHMMSS) */}
          <input type="hidden" name="ordertm" value={orderStore.paymentData.ediTime} />
          {/* 무결섬 검증 Hash 값 */}
          <input type="hidden" name="checkHash" value={orderStore.paymentData.signData} />
          {/* 할부개월수(MM) 00으로 고정 */}
          <input type="hidden" name="quota" value="00" />

          {/************************* 옵션 *************************/}
          {/* 구매자 ID (카카오페이의 경우 필수) */}
          <input type="hidden" name="buyerid" value={orderStore.orderData.userId} />
          {/* 구매자명 */}
          <input type="hidden" name="buyernm" value={orderStore.orderData.userId} />
          {/* 구매자e-mail */}
          <input type="hidden" name="buyerEmail" value="" />
          {/* 가맹점 예약 필드1 */}
          <input
            type="hidden"
            name="reserved01"
            value={`${commonStore.companyId}|${commonStore.storeCode}|${orderStore.isLiteOrder}`}
          />
          {/* 가맹점 예약 필드2 */}
          <input type="hidden" name="reserved02" value="" />
          {/* 모바일용 APP Scheme Uri */}
          <input type="hidden" name="returnAppUrl" value="" />
        </form>

        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(PaymentCoam);
